import { Message } from 'element-ui';

/**
 * 处理「创建应用」类接口的额度错误。
 *
 * 后端在额度用尽时回 403 + {"detail": {"code": "QUOTA_EXCEEDED", "used", "limit"}}。
 * 回错误码而非文案，是因为文案属于呈现层——本产品有 cn / hk / en 三种语言，
 * 后端写死简体中文会让英文与港版使用者看到看不懂的字。
 * 详见后端 docs/TEACHER_APP_QUOTA.md
 *
 * @param {Error} error   axios 抛出的错误
 * @param {Object} lang   组件的 this.lang
 * @returns {boolean}     true = 已提示使用者，呼叫端不需再处理
 */
export function handleCreateAppError(error, lang) {
  const detail =
    error && error.response && error.response.data && error.response.data.detail;
  if (!detail || detail.code !== 'QUOTA_EXCEEDED') {
    return false;
  }
  const template =
    (lang && lang.quota_exceeded) ||
    '本学期应用创建次数已达上限（{used}/{limit}），删除不再使用的应用后可继续创建';
  Message.error(
    template.replace('{used}', detail.used).replace('{limit}', detail.limit)
  );
  return true;
}
